module.exports = __webpack_public_path__ + "img/smart-m-1.e61207ce.jpg";